import { useState } from 'react';
import posthog from 'posthog-js';
import {
  useExtForms,
  useExtFormsOtp,
  useExtFormsSign,
} from '../../../api/extForms';
import { useExtFormStepController } from './useExtFormStepController';

/**
 * UseFormControllerPageOptions type
 */
export type UseFormControllerPageOptions = {
  /**
   * Form share id
   * @example '71aa14e2-6633-4235-b375-f929e3797e76'
   */
  formShareId: string;
};

/**
 * useFormControllerPage hook
 * Use this hook to handle the Offer Page component logic.
 */
export const useExtFormPageController = (
  options: UseFormControllerPageOptions,
) => {
  /**
   * Hook to get the external form data
   */
  const { data, accessCodeRequired, isLoading, mutateAsync } = useExtForms(
    options.formShareId,
  );

  const navigation = useExtFormStepController(data);

  /**
   * Hook to send the OTP
   */
  const { mutateAsync: sendOtp } = useExtFormsOtp(options.formShareId);

  /**
   * Hook to send the form
   */
  const { mutateAsync: sendFormToApi } = useExtFormsSign(options.formShareId);

  const [values, setValues] = useState({});

  const sendForm = async (formData: any) => {
    await sendFormToApi(formData);
    posthog.capture('FormsSendSuccess');
    navigation.setStepByName('submitted');
  };

  return {
    ...navigation,
    sendOtp,
    data,
    accessCodeRequired,
    isLoading,
    setAccessCode: mutateAsync,
    values,
    setValues,
    sendForm,
  };
};
